// removed by extract-text-webpack-plugin
module.exports = {"header":"_0448823d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AppointmentForm/AppointmentPatientInfo/styles.styl
// module id = 4896
// module chunks = 39